// extracted by mini-css-extract-plugin
module.exports = {"box":"EmptyListingBox_box_2w9q0","spinAround":"EmptyListingBox_spinAround_2SWUu"};